export enum CategoryRequirementTypeEnum {
  AVERAGE_BET_AMOUNT = 'average_bet_amount',
  AVERAGE_REAL_MONEY_BET_AMOUNT = 'average_real_money_bet_amount',
  AVERAGE_DEPOSIT_AMOUNT = 'average_deposit_amount',
}
